import API_URLS from "constants/apis.url";

import { extractLayout, getLayoutURL } from "../utils/utils.js";

import { deleteRequest, getRequest, paramsSerializer, postRequest, putRequest } from "./api";

const REPORT_URL = API_URLS.reportsURL;

const getURL = (id = null) => (id ? `${REPORT_URL}/${id}/widgets` : REPORT_URL);

export const getReport = layout => {
  if (layout === null) {
    return getRequest(`${API_URLS.reportsURL}`);
  }

  const layoutURL = getLayoutURL(API_URLS.reportsURL, layout);
  return getRequest(layoutURL);
};

export const deleteWidgetApi = async (layoutID, widgetID) => await deleteRequest(`${getURL(layoutID)}/${widgetID}`);

export const addWidgetApi = async widgetData => {
  const { LayoutID, ...payload } = widgetData;
  return await postRequest(`${getURL(LayoutID)}`, payload);
};

export const getWidgetApi = async LayoutID => {
  const { ID } = LayoutID;
  return getRequest(`${REPORT_URL}/${ID}`);
};

export const editWidgetApi = async widgetData => {
  const { LayoutID, Id, ...payload } = widgetData;
  return await putRequest(`${getURL(LayoutID)}/${Id}`, payload);
};

export const editAutogenerate = async data => {
  const { LayoutID, ...payload } = data;
  return await putRequest(`${API_URLS.reportsURL}/${LayoutID}/schedule`, payload);
};

export const editAutogenerateSwitch = async data => {
  const { LayoutID, ...payload } = data;
  return await postRequest(`${API_URLS.reportsURL}/${LayoutID}/schedule`, payload);
};

export const reorderReportWidgets = async data => {
  const { LayoutID, ...payload } = data;
  return await postRequest(`${API_URLS.reportsURL}/${LayoutID}/${API_URLS.widgets}/${API_URLS.reorder}`, payload, false, true);
};

export const getReportsHistory = () => getRequest(API_URLS.reportsHistoryURL);

export const downloadReport = reportID => {
  const file = `${reportID}.pdf`;
  return getRequest(`${API_URLS.reportsHistoryURL}/${file}`);
};

export const deleteReport = async reportID => {
  const file = `${reportID}.pdf`;
  return await deleteRequest(`${API_URLS.reportsHistoryURL}/${file}`);
};

export const downloadReportWidgetImage = (params, widgetID) => getRequest(`${getURL(extractLayout())}/${widgetID}`, true, { params });

export const deleteAllComments = async () => await deleteRequest(`${API_URLS.reportsURL}/${extractLayout()}/comments`);

export const getBaselineList = () => getRequest("/baselines");

export const getNormalizationFilters = () => {
  getRequest("/baselines");
};

export const getChartJson = payload => {
  const { layoutID, widgetID, ...params } = payload;
  return getRequest(`${getURL()}/${layoutID}/widgets/${widgetID}/data`, true, { params });
};

export const getAlarmsList = payload => {
  const { layoutID, ...params } = payload;
  return getRequest(`${API_URLS.reportsURL}/${layoutID}${API_URLS.alarms}`, true, { params }, true);
};

export const getTimeSeriesData = params => {
  const payload = { params, paramsSerializer };
  return getRequest(`${REPORT_URL}/${API_URLS.timeSeriesURL}`, true, payload);
};

export const getAccumulativeData = params => {
  const payload = { params, paramsSerializer };
  return getRequest(`${REPORT_URL}/${API_URLS.accumulativeDataURL}`, true, payload);
};

export const getWidgetData = (params, widgetID) => getRequest(`${API_URLS.widgets}/${widgetID}/data`, true, { params });
export const getNormalizationData = params => {
  const payload = { params, paramsSerializer };
  return getRequest(`${API_URLS.normalizationData}`, true, payload);
};

export const getNormalizeDefaultValues = () => getRequest(API_URLS.normalizationRanges);

export const addAllWidgets = async payload => {
  const { layoutID, ...params } = payload;
  return await putRequest(`${REPORT_URL}/${layoutID}${API_URLS.enableWidget}`, params);
};
